import { ICompletenessData } from 'legacy/lut/features/partner360/completeness/models/completeness'
import { getOwnerId } from 'legacy/lut/selectors/app'
import { recalculateCompletenessProcedure } from 'legacy/lut/services/partner360/completeness/recalculateCompletenessProcedure'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { REQUEST_RECALCULATE_COMPLETENESS } from '../constants'

interface IRecalculateCompletenessParams {
  partnerId: string
  fYear: number
}

export const requestRecalculateCompleteness = createAsyncThunk<
  ICompletenessData[],
  IRecalculateCompletenessParams
>(
  REQUEST_RECALCULATE_COMPLETENESS,
  async ({ partnerId, fYear }, { getState }) => {
    const ownerId = compose(getOwnerId, getState)()
    return await recalculateCompletenessProcedure({
      partnerId,
      fYear,
      ownerId,
    })
  },
  {
    condition({ fYear, partnerId }) {
      if (!fYear || !partnerId) {
        return false
      }

      return
    },
  }
)
